import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Message, Divider } from 'semantic-ui-react'
import DropzoneComponent from 'react-dropzone-component';
import moment from 'moment';
import _ from 'lodash';
// import uuidv1 from 'uuid/v1';

import FormsInputsText from '../../../inputs/text/forms_inputs_text';
import FormsInputDate from '../../../inputs/date';
import FormsInputDropdown from '../../../inputs/dropdown';
import FormsInputsDropdownAddition from '../../../inputs/dropdownaddition';
import HradminAddClaimValidationSchema from './validation';
import { djsConfig } from '../../../../../template/DropZoneTemplate';

var componentConfig = {
    iconFiletypes: ['.jpg', '.jpeg', '.png', '.pdf'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
// var djsConfig = {
//     autoProcessQueue: false ,
//     addRemoveLinks: true
// }

const prePostOthersOptions = [
    { text: 'Pre / Post Hospitalisation', value: 'Y' },
    { text: 'Others', value: 'N'}
];

const typeOfClaimOptions = [
    { text: 'Inpatient Claim', value: 'Inpatient Claim' },
    { text: 'Outpatient Claim', value: 'Outpatient Claim'}
];

const prepareDynamicDropDownSelection = (list, useValueAsText = false, useTextAsValue = false) => {
    return _.map(list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
};

class FormsHradminEmployeeAddClaimForm extends Component {
    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false
    }
    updateFileTest(file) {
        this.setState({files: [...this.state.files, file]});
    }
    removeFile(file) { 
        this.setState({
            files: this.state.files.filter(f => f !== file),
            error:false,
            errorMessage:''});
    }
    renderClaimSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>
                        Claim Created Successfully!
                    </Message.Header>
                    <p>
                        You will be updated on the progress and outcome via e-mail.
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    checkAttachmentFile() {
        if (this.state.files.find( (file) => file.size >= 5242880)) {
            return (
                <Message negative>
                    <p>
                        { 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.' }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const { cl, hl } = this.props.claimOptions;
        return (
            <Formik
                initialValues={{
                    typeOfClaim: 'Inpatient Claim',
                    providerName: '',
                    currency: 'SGD',
                    amount: '',
                    admissionDate: moment(),
                    dischargeDate: moment(),
                    visitDate: moment(),
                    receiptNo: '',
                    prePostHospitalisation: '',
                }}
                validate={(values) => {
                    // Additional Validation (if any)
                    let error = {};
                    if (this.state.files.length === 0) {
                        error.uploadAttachments = 'No Files Uploaded.';
                    }
                    if (this.state.files.length > 10) {
                        error.uploadAttachments = 'Only a maxmum of 10 files can be uploaded';
                    }
                    if (this.state.files.find( (file) => file.size >= 5242880 )) {
                        error.maxFileSize = 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.';
                    }
                    return error;
                }}
                validationSchema={HradminAddClaimValidationSchema}
                onSubmit={(values, actions) => {
                    // console.log(values, actions);
                    // Additional Validation (if any)
                    // Prepare Data To Submit
                    // 0 - Create a Copy of current "values" object
                    let data = {};
                    // Type = Inpatient Claim
                    if (values.typeOfClaim === 'Inpatient Claim') {
                        data.admissionDate = moment(values.admissionDate).format('DD/MM/YYYY');
                        data.dischargeDate = moment(values.dischargeDate).format('DD/MM/YYYY');
                    }
                    // Type = Outpatient Claim
                    if (values.typeOfClaim === 'Outpatient Claim') {
                        data.prePostHospitalisation = values.prePostHospitalisation;
                        data.visitDate = moment(values.visitDate).format('DD/MM/YYYY');
                        data.receiptNo = values.receiptNo;
                    }
                    // Load Generic Data
                    data.typeOfClaim = values.typeOfClaim;
                    data.providerName = values.providerName;
                    data.currency = values.currency;
                    data.amount = values.amount;
                    // Submit Data to Action Handler
                    // console.log(data);
                    this.props.submitHradminEmployeeHrClaimData({data, attachments: this.state.files, userId: this.props.targetUserId, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log(result, error, 'done');
                        if (error) {
                            console.log('done-failed');
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.message});
                        }
                        if (result) {
                            console.log('done-success');
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{paddingBottom: 20}}>
                        <Grid columns={2}>
                            <Grid.Column width={16}>
                                <Message warning>
                                    <Message.Header>IMPORTANT</Message.Header>
                                    <p>
                                        Please read these instructions carefully before uploading the documents.
                                    </p>
                                    <p>
                                        1. Please scan and upload original bills and receipts. Original bills and receipts must show claimant's name, date of treatment, diagnosis and must have the attending physician's stamp and signature.
                                    </p>
                                    <p>
                                        2. Claims for Specialist Outpatient Treatment or X-rays/ Laboratory tests must include a copy of General Practitioner (GP)'s referral letter for the first consultation. Visits to the specialist which are more than 1 year apart require a new referral letter from a GP. (Not applicable to dental claim).
                                    </p>
                                    <p>
                                        3. Claims for purchase of drugs must include a copy of the attending doctor's prescription (Not applicable to dental claim).
                                    </p>
                                    <p>
                                        4. For admission in a Singapore Government/ Restructured Hospital, please scan a copy of the Inpatient Discharge Summary/ Ambulatory Form/ Hospital Pre-Admission Form.
                                    </p>
                                    <p>
                                        5. For admission in a private/ overseas hospital, please provide itemised/detailed hospital bill with Section 2 completed by the attending doctor. If the attending doctor charges a fee for completion of Section 2 the employer or employee/patient is responsible to pay the charges.
                                    </p>
                                </Message>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    General Claim Information
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="typeOfClaim"
                                    options={typeOfClaimOptions}
                                    label="Type of Claim"
                                    secondaryLabel="Select the type of claim to submit"
                                    component={FormsInputDropdown}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="providerName"
                                    label="Hospital"
                                    options={prepareDynamicDropDownSelection(hl, false, true)}
                                    component={FormsInputsDropdownAddition}
                                    secondaryLabel="Select the hospital"
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="currency"
                                    options={prepareDynamicDropDownSelection(cl, true)}
                                    label="Currency"
                                    secondaryLabel="Select the incurred amount currency"
                                    component={FormsInputDropdown}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="amount"
                                    label="Amount"
                                    component={FormsInputsText}
                                    secondaryLabel="Input the incurred claim amount"
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Specific Claim Information
                                </Divider>
                            </Grid.Column>
                            {
                                (values.typeOfClaim === 'Inpatient Claim') ?
                                (
                                    <Grid.Column>
                                        <Field
                                            name="admissionDate"
                                            component={FormsInputDate}
                                            label="Admission Date"
                                            secondaryLabel="Input the date of admission to hospital"
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                )
                                : null
                            }
                            {
                                (values.typeOfClaim === 'Inpatient Claim') ?
                                (
                                    <Grid.Column>
                                        <Field
                                            name="dischargeDate"
                                            component={FormsInputDate}
                                            label="Discharge Date"
                                            secondaryLabel="Input the date of discharge from hospital"
                                            minDate={values.admissionDate}
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                )
                                : null
                            }
                            {
                                (values.typeOfClaim === 'Outpatient Claim') ?
                                (
                                    <Grid.Column>
                                        <Field
                                            name="prePostHospitalisation"
                                            options={prePostOthersOptions}
                                            label="Type of Visit"
                                            secondaryLabel="Is your visit a pre / post hospitalisation or others"
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                )
                                : null
                            }
                            {
                                (values.typeOfClaim === 'Outpatient Claim') ?
                                (
                                    <Grid.Column>
                                        <Field
                                            name="visitDate"
                                            component={FormsInputDate}
                                            label="Visit Date"
                                            secondaryLabel="Select the date of visit"
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                )
                                : null
                            }
                            {
                                (values.typeOfClaim === 'Outpatient Claim') ?
                                (
                                    <Grid.Column width={16}>
                                        <Field
                                            name="receiptNo"
                                            label="Receipt/Invoice Number"
                                            component={FormsInputsText}
                                            secondaryLabel="Input the receipt unique identifier / number"
                                        />
                                    </Grid.Column>
                                )
                                : null
                            }
                        </Grid>

                        <Grid.Column width={16}>
                            <Divider horizontal>
                                All Required Documents, Documentary Proofs, Medical Reports
                            </Divider>
                        </Grid.Column>

                        <Grid.Column width={16}>
                        {
                            (values.typeOfClaim === 'Inpatient Claim') ?
                            (
                                <Message negative>
                                    <Message.Header>Important!</Message.Header>
                                    <p>
                                        You are required to complete section 1 of the Group Hospital & Surgical Claim Form
                                        <br />
                                        <a href='https://www.income.com.sg/forms/claims/hospitalisation-ghs.aspx' target='_blank'>
                                            https://www.income.com.sg/forms/claims/hospitalisation-ghs.aspx
                                        </a>
                                    </p>
                                </Message>
                            )
                            :
                            (
                                <Message negative>
                                    <Message.Header>Important!</Message.Header>
                                    <p>
                                        You are required to complete the  Group Outpatient Medical Claim Form
                                        <br />
                                        <a href='https://www.income.com.sg/forms/claims/group-outpatient-medical-claim.aspx' target='_blank'>
                                            https://www.income.com.sg/forms/claims/group-outpatient-medical-claim.aspx
                                        </a>
                                    </p>
                                </Message>
                            )
                        }
                        </Grid.Column>

                        <Grid.Column width={16}>
                            <Message warning>
                                <p>
                                    Please prepare scanned copy of your supporting documents for upload before proceeding with this new eSubmission.
                                </p>
                                <p>
                                    Scan files must meet the following criteria:
                                </p>
                                <ul>
                                    <li>
                                        Acceptable file formats are pdf, jpg, jpeg and png
                                    </li>
                                    <li>
                                        Maximum allowable size for each attachment is up to 5MB
                                    </li>
                                </ul>
                                <p>
                                    Please note that you must keep the original tax invoice(s)/receipt(s) for at least 6 months from claim submission date and must be made readily available upon Insurer's request. Please ensure your email address and handphone number updated in the e-claim portal are correct.
                                </p>
                                <p>
                                    When we pay an eligible claim, precedence shall be given in the following order:
                                </p>
                                <ul>
                                    <li>
                                        Employee if they have settled the eligible medical bills by cash
                                    </li>
                                    <li>
                                        Medisave account as indicated in the tax invoices or bills
                                    </li>
                                    <li>
                                        Patient's Medisave-Approved Integrated Shield Plan or CPF Medishield Life (if applicable) in accordance with the CPF Act.
                                    </li>
                                </ul>
                            </Message>
                        </Grid.Column>

                        <Grid.Column width={16}>
                            <DropzoneComponent
                                config={componentConfig}
                                eventHandlers={
                                    {
                                        addedfile: (file) => {
                                            // console.log(file);
                                            if (file.type.includes('jpeg')||
                                                file.type.includes('jpg')||
                                                file.type.includes('png')||
                                                file.type.includes('pdf')||
                                                file.type.includes('heif')||
                                                file.type.includes('heic')){
                                                    this.updateFileTest(file);
                                                } else {
                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                }
                                        },
                                        removedfile: (file) => {
                                            this.removeFile(file);
                                        }
                                    }
                                }
                                djsConfig={djsConfig}
                            />
                            {this.checkAttachmentFile()}
                            {
                                (errors['uploadAttachments']) &&
                                (
                                    <Message negative>
                                        {errors['uploadAttachments']}
                                    </Message>
                                )
                            }
                        </Grid.Column>

                        <Grid.Column width={16}>
                            {this.renderClaimSubmissionResult()}
                        </Grid.Column>

                        <Grid.Column width={16}>
                            <Button
                                loading={isSubmitting}
                                type="submit"
                                primary
                                disabled={isSubmitting}
                                fluid
                                size="big"
                            >
                                Submit Claim
                            </Button>
                        </Grid.Column>
                    </Form>
                )}
            />
        );
    }
}

export default FormsHradminEmployeeAddClaimForm;
